import React from "react";

const TermsPage: React.FC = () => {
    return (
      <>
        <div style={{ paddingLeft: "20px", paddingRight: "20px" }}>
          <h1>CampusPocket 利用規約</h1>

          <p>
            この文書は、CampusPocket (以下、「当アプリ」といいます)
            の利用条件を定めたものです。当アプリをダウンロードし、利用する際には、以下の利用規約に同意したものとみなされます。
          </p>

          <h2>1. ダウンロードと利用の同意</h2>
          <p>
            1.1
            当アプリをダウンロードし、利用することで、ユーザーはこの利用規約に同意したものとみなされます。
          </p>
          <p>
            1.2
            ユーザーは、この利用規約に同意しない場合は当アプリをダウンロードせずに利用を中止してください。
          </p>

          <h2>2. 利用者（ユーザ）に関する条件</h2>
          <p>
            2.1
            当アプリの利用には、利用者は適用される法律と規制を順守する必要があります。
          </p>
          <p>
            2.2
            ユーザーは、正確な情報を提供し、他のユーザーに対して配慮を持つことが求められます。
          </p>

          <h2>3. 物的設備に関する条件</h2>
          <p>
            3.1
            当アプリの利用には、適切なスマートフォンまたはタブレット端末が必要です。
          </p>
          <p>
            3.2
            ユーザーは、自己の責任でインターネット接続を確保する必要があります。
          </p>

          <h2>4. 金銭負担に関する条件</h2>
          <p>
            4.1
            当アプリの基本的な利用は無料ですが、一部の特定の機能やコンテンツは有料となる場合があります。
          </p>
          <p>
            4.2
            有料コンテンツの利用には、ユーザーは適切な支払い方法を提供する必要があります。
          </p>

          <h2>5. コンテンツ（情報）に関する条件</h2>
          <p>
            5.1
            当アプリに掲載されているコンテンツや情報は、学祭主催者が提供するものであり、その正確性や信頼性について開発者は保証しません。
          </p>
          <p>
            5.2
            学祭主催者が提供するコンテンツは、第三者の知的財産権を侵害していないことを保証するものとします。
          </p>

          <h2>6. 権利義務等の譲渡</h2>
          <p>
            6.1
            当社がアプリ事業を第三者に譲渡した場合（事業を譲渡する場合のみならず、合併、会社分割等のM&amp;Aによる場合も含みます。）、当社は、利用規約に基づく権利義務、契約上の地位、会員登録事項や顧客登録情報等のアプリ上の情報を当該第三者に譲渡できるものとします。
          </p>

          <h2>7. ユーザの同意</h2>
          <p>
            7.1 ユーザは、前項の定める内容について予め合意したものとします。
          </p>

          <h2>8. サービスの変更と終了</h2>
          <p>
            8.1
            開発者は、予告なく当アプリの内容やサービスを変更、一時的にまたは永久的に終了することがあります。ユーザーに対する事前の通知は行うものの、開発者はその理由を問わずこれにより生じる損害に対して一切の責任を負いません。
          </p>

          <h2>9. 免責事項</h2>
          <p>
            9.1
            当アプリの利用により生じるいかなる損害についても、開発者は一切の責任を負いません。
          </p>
          <p>
            9.2
            当アプリにリンクされている第三者のウェブサイトやアプリに関して、開発者は一切の責任を負いません。
          </p>

          <h2>10. その他の規定</h2>
          <p>10.1 本利用規約は、日本法に準拠し、解釈されます。</p>
          <p>
            10.2
            本利用規約は、ユーザーと開発者との間で完全かつ排他的な合意を構成します。
          </p>

          <p>最終更新日: 2023年8月6日</p>
        </div>
      </>
    );
};

export default TermsPage;
